(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fahrzeug-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.fz-show');
  if (!root) return;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('fz-js');

  function fmt(n) { return n.toLocaleString('de-DE'); }
  function count(el) {
    var end = parseFloat(el.getAttribute('data-count'));
    if (still) { el.firstChild.nodeValue = fmt(end); return; }
    var t0 = null, dur = 1500;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      el.firstChild.nodeValue = fmt(Math.round(end * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // Alles, was beim Scrollen erscheint. Prüfung per Position statt IntersectionObserver,
  // damit auch übersprungene Bereiche (Sprunglink, schnelles Wischen) sicher erscheinen.
  var pending = Array.prototype.slice.call(root.querySelectorAll('.fz-r, .fz-bars, [data-count]'));
  pending.forEach(function (el) {
    if (el.hasAttribute('data-count') && el.getBoundingClientRect().top > window.innerHeight) el.firstChild.nodeValue = '0';
  });
  function reveal() {
    var limit = window.innerHeight * 0.92;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top > limit) return true;
      el.classList.add('is-in');
      if (el.hasAttribute('data-count')) count(el);
      return false;
    });
  }

  // Parallax: LS-E-Schriftzug wandert beim Scrollen hinter das Auto
  var hero = root.querySelector('.fz-hero__stage');
  var word = root.querySelector('.fz-hero__word');
  function parallax() {
    if (!hero || !word || still) return;
    var r = hero.getBoundingClientRect();
    if (r.bottom > 0) word.style.transform = 'translate3d(0,' + Math.max(0, -r.top) * 0.32 + 'px,0)';
  }

  var ticking = false;
  function onScroll() {
    reveal();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { parallax(); ticking = false; });
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', onScroll);
  reveal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knepper-te-galerie"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.te-video__fassade[data-video-id]').forEach(function (fassade) {
  fassade.addEventListener('click', function (e) {
    e.preventDefault();
    // Klick auf das beschriftete Thumbnail = Einwilligung (Zwei-Klick-Lösung):
    // Usercentrics Smart Data Protector für YouTube (Template BJz7qNsdj-7) freigeben,
    // sonst ersetzt er das iframe durch sein Zustimmungs-Overlay.
    try {
      if (window.uc && typeof window.uc.deactivateBlocking === 'function') {
        window.uc.deactivateBlocking(['BJz7qNsdj-7']);
      }
    } catch (err) { /* ohne SDP einfach weiter */ }
    var id = fassade.getAttribute('data-video-id');
    var iframe = document.createElement('iframe');
    iframe.className = 'te-video__iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
    iframe.title = fassade.getAttribute('aria-label') || 'YouTube-Video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.setAttribute('allowfullscreen', '');
    fassade.replaceChildren(iframe);
    fassade.removeAttribute('href');
    fassade.removeAttribute('data-video-id');
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knepper-youtube"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.knepper-yt__link').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var id = link.dataset.videoId;
    if (!id) return;
    e.preventDefault();
    var iframe = document.createElement('iframe');
    iframe.className = 'knepper-yt__iframe';
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = link.getAttribute('aria-label') || 'YouTube-Video';
    link.replaceChildren(iframe);
    link.removeAttribute('href');
    link.classList.add('knepper-yt__link--active');
  }, { once: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knepper-yt-kanal"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.kyk').forEach(function (root) {
    var api = root.dataset.api;
    var en = root.dataset.lang === 'en';
    var loc = en ? 'en-US' : 'de-DE';
    var track = root.querySelector('[data-track]');
    var dialog = root.querySelector('.kyk__dialog');
    var data = null;
    var KEY = 'knepper-yt-ok';
    var T = en
      ? { abonnenten: 'subscribers', videos: 'videos', aufrufe: 'views', aufrufeKurz: 'views' }
      : { abonnenten: 'Abonnenten', videos: 'Videos', aufrufe: 'Aufrufe', aufrufeKurz: 'Aufrufe' };

    function zahl(n) { return new Intl.NumberFormat(loc).format(n); }
    function kurz(n) { return new Intl.NumberFormat(loc, { notation: 'compact', maximumFractionDigits: 1 }).format(n); }
    function dauer(s) {
      if (s == null) return '';
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sek = String(s % 60).padStart(2, '0');
      return h ? h + ':' + String(m).padStart(2, '0') + ':' + sek : m + ':' + sek;
    }
    function vorZeit(iso) {
      var diff = (Date.parse(iso) - Date.now()) / 1000;
      var rtf = new Intl.RelativeTimeFormat(loc, { numeric: 'auto' });
      var steps = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600]];
      for (var i = 0; i < steps.length; i++) if (Math.abs(diff) >= steps[i][1]) return rtf.format(Math.round(diff / steps[i][1]), steps[i][0]);
      return rtf.format(Math.round(diff / 60), 'minute');
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    function render(tab) {
      var list = data[tab] || [];
      track.classList.toggle('kyk__track--shorts', tab === 'shorts');
      track.innerHTML = list.map(function (v) {
        var meta = [v.aufrufe != null ? kurz(v.aufrufe) + ' ' + T.aufrufeKurz : '', v.datum ? vorZeit(v.datum) : ''].filter(Boolean).join(' · ');
        return '<li class="kyk__item"><a class="kyk__link" href="https://www.youtube.com/' + (v.short ? 'shorts/' : 'watch?v=') + v.id + '" target="_blank" rel="noopener" data-id="' + v.id + '" data-titel="' + esc(v.titel) + '"' + (v.short ? ' data-short="1"' : '') + '>' +
          '<span class="kyk__thumb"><img src="' + api + '?bild=' + v.id + '" alt="" loading="lazy"><span class="kyk__play" aria-hidden="true"></span>' +
          (v.dauer && !v.short ? '<span class="kyk__dauer">' + dauer(v.dauer) + '</span>' : '') + '</span>' +
          '<span class="kyk__titel">' + esc(v.titel) + '</span>' + (meta ? '<span class="kyk__meta">' + meta + '</span>' : '') + '</a></li>';
      }).join('');
      track.scrollLeft = 0;
    }

    function kopf(k) {
      var stats = root.querySelector('[data-stats]');
      var items = [];
      if (k.abonnenten != null) items.push('<li><b>' + zahl(k.abonnenten) + '</b> ' + T.abonnenten + '</li>');
      if (k.videos != null) items.push('<li><b>' + zahl(k.videos) + '</b> ' + T.videos + '</li>');
      if (k.aufrufe != null) items.push('<li><b>' + zahl(k.aufrufe) + '</b> ' + T.aufrufe + '</li>');
      if (items.length) stats.innerHTML = items.join('');
      if (k.name) root.querySelector('.kyk__name').textContent = k.name;
      var av = root.querySelector('.kyk__avatar');
      var img = new Image();
      img.className = 'kyk__avatar-img'; img.alt = '';
      img.onload = function () { av.replaceChildren(img); };
      img.src = api + '?bild=kanal';
    }

    if (api && window.fetch) {
      var ctl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
      fetch(api, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        clearTimeout(timer);
        if (!d || !d.ok || !d.videos || !d.videos.length) return; // keep the fallback blocks
        data = d;
        kopf(d.kanal || {});
        render('videos');
        if (d.shorts && d.shorts.length) root.querySelector('.kyk__tabs').hidden = false;
      }).catch(function () {});
    }

    root.querySelectorAll('.kyk__tab').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.kyk__tab').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-selected', x === b); });
        render(b.dataset.tab);
      });
    });
    root.querySelectorAll('.kyk__pfeil').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.9, behavior: 'smooth' }); });
    });

    // Player: only after confirmation (or if confirmed earlier in this visit)
    var player = dialog.querySelector('.kyk__player');
    function play(id) {
      // The visitor confirmed in our dialog: lift the Usercentrics Smart Data Protector block for
      // "YouTube Video" (template BJz7qNsdj-7), same as assets/knepper-yt-facade.js. Without it the
      // nocookie iframe is replaced by the Usercentrics placeholder.
      try { if (window.uc && typeof window.uc.deactivateBlocking === 'function') window.uc.deactivateBlocking(['BJz7qNsdj-7']); } catch (err) {}
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.title = 'YouTube-Video';
      player.replaceChildren(f);
      dialog.classList.add('is-playing');
    }
    track.addEventListener('click', function (e) {
      var a = e.target.closest('.kyk__link');
      if (!a || !dialog.showModal) return; // without <dialog> support the link opens YouTube
      e.preventDefault();
      dialog.classList.remove('is-playing');
      dialog.classList.toggle('is-short', !!a.dataset.short);
      dialog.querySelector('.kyk__dialog-titel').textContent = a.dataset.titel || '';
      dialog.querySelector('.kyk__extern').href = a.href;
      dialog.dataset.id = a.dataset.id;
      dialog.showModal();
      var ok = false;
      try { ok = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
      if (ok) play(a.dataset.id);
    });
    dialog.querySelector('.kyk__ok').addEventListener('click', function () {
      if (dialog.querySelector('.kyk__merken input').checked) { try { sessionStorage.setItem(KEY, '1'); } catch (err) {} }
      play(dialog.dataset.id);
    });
    function zu() { player.replaceChildren(); dialog.close(); }
    dialog.querySelector('.kyk__zu').addEventListener('click', zu);
    dialog.querySelector('.kyk__extern').addEventListener('click', function () { setTimeout(zu, 0); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) zu(); });
    dialog.addEventListener('close', function () { player.replaceChildren(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
